enum BillingContributionType {
  BONUS = "BONUS",
  PENALTY = "PENALTY",
}

export default BillingContributionType;
